<template>
	<td :colspan="header.colspan"
		:class="[header.align ? 'text-' + header.align : 'text-left', {'bg-gray-150': !!parent, 'bg-white': !!header.sticky && !parent, 'px-0': header.value === 'expand', 'sticky-right': header.sticky === 'right', 'sticky-left': header.sticky === 'left'}]"
		:align="header.align">
		<div v-if="header.value === 'expand'">
			<btn v-if="expandable" rounded-full text icon class="w-32 min-w-32 h-32" @click.stop="$emit('expand')">
				<Icon force-size :icon="item._expand ? icons.up : icons.down" color="gray-400"/>
			</btn>
		</div>
		<template v-else-if="header.value === 'actions'">
			<client-only>
				<dropdown class="flex justify-center" nudge-right>
					<Icon :icon="icons.settings" small class="text-gray-400 cursor-pointer"/>
					<template #menu>
						<nav-list>
							<slot name="actions"/>
						</nav-list>
					</template>
				</dropdown>
			</client-only>
		</template>
		<div v-else class="flex items-center" :class="[header.align ? 'justify-' + header.align : 'justify-start']">
			<slot>
				<table-body-cell :parent="parent" :item="item" :column="header" :reduced="reduced"/>
			</slot>
		</div>
	</td>
</template>

<script>
import Clickable from "../../mixins/Clickable";
	import {downIcon, settingsIcon, upIcon} from "../../config";
    export default {
        name: 'TableBodyRowData',

        mixins: [Clickable],

		emits: ['expand'],

        props: {
            // The column (header) of the table
            header: {
                type: Object,
                required: true
            },

            // The item being display in the row
            item: {
                type: Object,
                required: true
            },

            // The parent row data when the row item is a child
            parent: {
                type: Object,
                default: null
            },

            // The child parent row data when the row item is a child of a child
            subParent: {
                type: Object,
                default: null
            },

            // Whether the row can be expanded by click to display more infos
            expandable: {
                type: Boolean,
                default: false
            },

            // Whether the row shall display a short value version on its cells
            reduced: {
                type: Boolean,
                default: false
            }
        },

		data() {
			return {
				icons: {
					settings: settingsIcon,
					up: upIcon,
					down: downIcon,
				}
			}
		},

        computed: {
            isClickable() {
                return this.clickable || this.expandable;
            }
        }

    }
</script>